import { Pin } from '@/api/ms-item/services/interfaces/Items';
import { Actor } from '@/api/ms-item/services/interfaces/ItemPin';

export default (pins: Pin[], currentUser: Actor): boolean => {
  const pin = pins?.find((pin: Pin) => {
    return pin.actor?.username === currentUser.username && pin.pin;
  });
  return !!pin;
};
